import { useCurrentFrame, interpolate, Easing, useVideoConfig, AbsoluteFill } from "remotion";

// Variant 1 — Cyan electric: slide in from left → hold → exit right
export const ReelCTA1: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const HOLD_START = Math.round(fps * 0.4);
  const HOLD_END   = Math.round(fps * 2.6);
  const TOTAL      = Math.round(fps * 3);

  const slideIn  = interpolate(frame, [0, HOLD_START], [-720, 0], {
    extrapolateRight: "clamp", extrapolateLeft: "clamp",
    easing: Easing.bezier(0.16, 1, 0.3, 1),
  });
  const slideOut = interpolate(frame, [HOLD_END, TOTAL], [0, 720], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
    easing: Easing.bezier(0.7, 0, 0.84, 0),
  });
  const tx = frame < HOLD_END ? slideIn : slideOut;

  const scanY = (frame * 3) % 52;
  const glow  = 12 + Math.sin(frame * 2.8) * 5;

  return (
    <AbsoluteFill style={{ pointerEvents: "none", overflow: "hidden" }}>
      <div style={{ position:"absolute", bottom:"18%", left:"50%", transform:`translateX(calc(-50% + ${tx}px))`, whiteSpace:"nowrap" }}>
        <div style={{ background:"rgba(0,0,0,0.82)", borderRadius:6, padding:"9px 20px", border:"1px solid rgba(0,220,190,0.7)", boxShadow:`0 0 ${glow}px rgba(0,220,190,0.5)`, display:"flex", alignItems:"center", gap:9, position:"relative", overflow:"hidden" }}>
          <div style={{ position:"absolute", top:0, left:0, right:0, height:2, background:"rgba(0,220,190,0.5)", transform:`translateY(${scanY}px)` }} />
          <svg width="14" height="12" viewBox="0 0 18 14"><polygon points="0,0 18,7 0,14" fill="#00DCC0" /></svg>
          <span style={{ color:"#00DCC0", fontSize:27, fontWeight:900, fontFamily:"'Arial Black','Impact',sans-serif", letterSpacing:"0.06em", textShadow:`0 0 ${glow}px rgba(0,220,190,0.8),0 2px 6px rgba(0,0,0,0.9)` }}>WATCH FULL VIDEO</span>
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
